/**
 * GDSModules.js
 * Contains shared constants and utility functions for the GDS Builder.
 */

export const PROPAGATING_FIELDS = ["Case Type", "Connection Type"];
export const CARD_IMAGE_DESIRED_WIDTH = 232;
export const CARD_IMAGE_DESIRED_HEIGHT = 232;
export const MODAL_IMAGE_PREVIEW_WIDTH = 500;

/**
 * Formats a number in cents into a currency string.
 * @param {number} cents - Amount in cents.
 * @returns {string} - Formatted currency string (e.g., "$123.45").
 */
export function formatMoney(cents) {
    if (typeof cents !== 'number') {
        cents = parseInt(cents, 10) || 0;
    }
    const amount = cents / 100;
    return '$' + amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
}

/**
 * Modifies a Shopify CDN image URL to request a specific size.
 * @param {string} originalUrl - The original image URL from Shopify.
 * @param {number} width - The desired width for the image.
 * @param {number} [height] - Optional desired height.
 * @returns {string} - The modified URL.
 */
export function getSizedShopifyUrl(originalUrl, width, height) {
    if (!originalUrl || typeof originalUrl !== 'string') {
        return 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7'; // Transparent pixel
    }
    try {
        if (!originalUrl.includes('cdn.shopify.com/')) {
            return originalUrl;
        }
        const url = new URL(originalUrl.startsWith('//') ? `https:${originalUrl}` : originalUrl);
        url.pathname = url.pathname.replace(/_([a-zA-Z0-9]+x[a-zA-Z0-9]*|[a-zA-Z]+)(\.(jpe?g|png|gif|webp|avif))/i, '$2');
        if (width) url.searchParams.set('width', Math.round(width));
        if (height) url.searchParams.set('height', Math.round(height));
        return url.toString();
    } catch (e) {
        console.warn(`[getSizedShopifyUrl] Error processing URL: "${originalUrl}".`, e);
        return originalUrl;
    }
}

/**
 * Copies the current URL to the clipboard and shows a confirmation.
 */
export async function copyCurrentUrlToClipboard() {
    try {
        await navigator.clipboard.writeText(window.location.href);
        // This function will need access to the UI Feedback manager to show a confirmation
        // For now, we'll use a simple alert.
        alert('URL copied to clipboard!');
    } catch (error) {
        console.error('Failed to copy URL: ', error);
        alert('Failed to copy URL. Please try again.');
    }
}
